import React from "react";
import DocumentMeta from "react-document-meta";
import { Link } from "react-router-dom";
import { Component } from "react";
import * as myConstList from "../../Common/BaseUrl";
import axios from "axios";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { meta } from "../../Common/Meatdata";
import { PasswordValidation } from "../../Validation/PasswordValidation";
import { ProductName } from "../../Common/ProductName";

const baseUrl = myConstList.baseUrl;
const meta = {
  title: "Forgot | Green Crypto X  Exchange ",
  description:
    "Green Crypto X  Exchange Live Makes The Buying And Selling Of Crypto Coin Way More Effective And Profitable. We Are A Low Cost Cyrpto Exchange In India Like Bitcoin And Dogecoin.",
  canonical: "https://Green Crypto X  Exchange.live/buy-sell-crypto-online",
  meta: {
    charset: "utf-8",
    name: {
      keywords:
        "BTC Exchange, Crypto Trading Platform, Best Crypto Converter, Indian Crypto Exchange",
    },
  },
};

export class Forgot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisableEmail: false,
      codeMatchedStatus: false,
      timerText: "",
      counter: 0,
      textForCode: "Get Code",
      type: "password",
      type1: "password",
      buttonDisableVerification: true,
    };
  }

  handleChange2 = (event) => {
    var value = event.target.value;

    this.setState({
      textForCode: "",
      timerText: "Get Code",
      VerificationCode: "",
    });

    if (!event.target.value) {
      this.setState({
        mobileError: "This field is required",
        emailError: "",
        placeholder: "Enter Verification Code",
        mobile: "",
        email: "",
      });
      return false;
    }
    if (
      !isNaN(parseFloat(event.target.value)) &&
      !isNaN(event.target.value - 0) == true
    ) {
      var phoneno = /^\d{10}$/;
      if (value.match(phoneno)) {
        this.setState({ mobileError: "", emailError: "" });
      } else {
        this.setState({
          mobileError: "Please enter valid mobile number",
          emailError: "",
        });
      }
      this.setState({ mobile: event.target.value, email: "" });
    } else {
      var Email = event.target.value;
      if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(Email)) {
        this.setState({ emailError: "", mobileError: "" });
      } else {
        {
          this.setState({
            emailError: "Please enter a valid email address",
            mobileError: "",
          });
        }
      }
      this.setState({
        email: event.target.value,
        mobile: "",
        mobile: "",
      });
    }
  };

  handleChangePasswordSubmit = (event) => {
    event.preventDefault();

    var regex = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$";

    if (this.state.PasswordIssue || this.state.CPasswordIssue) {
      return false;
    }
    if (!this.state.Password) {
      this.setState({
        PasswordIssue: "This field is required",
      });
      return false;
    }
    if (!this.state.CPassword) {
      this.setState({
        CPasswordIssue: "This field is required",
      });
      return false;
    }

    if (!this.state.Password.match(regex)) {
      this.setState({
        PasswordIssue:
          "Password must 8 characters and contain at least one upper case letter, one lower case letter, one number, and one special character",
      });
      return false;
    }

    if (!(this.state.Password == this.state.CPassword)) {
      this.setState({
        CPasswordIssue: "Password miss matched",
      });
      return false;
    }

    this.setState({ disabledButton: true });
    setTimeout(() => this.setState({ disabledButton: false }), 5000);
    let params = {
      Password: this.state.Password,
      CPassword: this.state.CPassword,
    };
    if (this.state.email) {
      params.email = this.state.email;
    }
    if (this.state.mobile) {
      params.mobile = this.state.mobile;
    }

    axios.post(baseUrl + "/frontapi/forgotPassword", params).then((resp) => {
      var resp = resp.data;
      if (resp.status == true) {
        toast.dismiss();
        toast.success(resp.message);
        this.setState({
          Password: "",
          CPassword: "",
        });
        setTimeout(
          function () {
            window.location = "/login";
          }.bind(this),
          2000
        );
      }
      if (resp.status == false) {
        toast.dismiss();
        toast.error(resp.message);
      }
    });
  };

  handleMobileSubmit = (e) => {
    e.preventDefault();
    if (
      !this.state.mobile &&
      !this.state.email &&
      !this.state.VerificationCode
    ) {
      this.setState({
        mobileError: "This field is required",
        verificationError: "This field is required",
      });
      return false;
    }
    if (!this.state.mobile && !this.state.email) {
      this.setState({ mobileError: "This field is required" });
      return false;
    }
    if (!this.state.VerificationCode) {
      this.setState({ verificationError: "This field is required" });
      return false;
    }
    if (this.state.mobileError || this.state.emailError) {
      return false;
    }
    if (this.state.mobile) {
      var data = {
        mobile: this.state.mobile,
        page: "forgot",
        verification_code: this.state.VerificationCode,
      };
    }
    if (this.state.email) {
      var data = {
        email: this.state.email,
        page: "forgot",
        verification_code: this.state.VerificationCode,
      };
    }
    axios.post(baseUrl + "/frontapi/codeVerify", data).then((resp) => {
      var resp = resp.data;
      if (resp.status) {
        toast.success(resp.message);
        this.setState({ CPassword: "", Password: "" });
      } else {
        toast.error(resp.message);
      }
      this.setState({
        codeMatchedStatus: resp.status,
      });
    });
  };

  startCountdown(seconds) {
    let counter = seconds;
    const interval = setInterval(() => {
      this.setState({ counter: counter });
      this.setState({ btnDisable: true });
      this.setState({ timerText: "Resend In" });
      counter--;
      if (counter < 0) {
        clearInterval(interval);
        this.setState({ textForCode: "Resend Code" });
        this.setState({ btnDisable: false });
        this.setState({ timerText: "" });
      }
    }, 1000);
  }

  handlecodechange = async (e) => {
    let { name, value } = e.target;
    this.setState({
      [name]: value,
    });
    if (!value) {
      this.setState({ verificationError: "This field is required" });
    } else {
      this.setState({ verificationError: "" });
    }
  };

  getCode = async () => {
    if (!this.state.email && !this.state.mobile) {
      this.setState({
        emailError: "This field is required",
      });
      return false;
    }
    let registerData = {
      countryCode: this.state.countryCode,
      page: "forgot",
    };
    if (this.state.email) {
      registerData.email = this.state.email;
    }
    if (this.state.mobile) {
      registerData.mobile = this.state.mobile;
    }
    await axios
      .post(baseUrl + "/frontapi/getcode", registerData)
      .then((resp) => {
        // eslint-disable-next-line
        var resp = resp.data;
        if (resp.status === false) {
          toast.error(resp.EmailMessage);
        }
        this.setState({
          EmailMessageErr: resp.EmailMessage,
        });
        if (resp.status === true) {
          toast.success(resp.EmailMessage);
          this.startCountdown(30);
          this.setState({
            buttonDisableVerification: false,
            // VerificationCode: resp.code,
          });
          return false;
        }
        if (resp.status === false) {
          this.setState({ buttonDisableVerification: true });
          toast.error(resp.message);
          return false;
        }
      });
  };

  handleChange101 = (event) => {
    let { name, value, id } = event.target;
    this.setState({
      [id]: value,
      errMsg: "",
      textForCode: "Get Code",
      timerText: "Get Code",
    });

    // Password //
    if (name == "password") {
      var passwordError = PasswordValidation(name, value);
      this.setState({
        PasswordIssue: passwordError,
      });
      if (passwordError == "mismatched") {
        this.setState({
          CPasswordIssue: "Password mis-matched",
          PasswordIssue: "",
        });
      }
      if (passwordError == "") {
        this.setState({
          CPasswordIssue: "",
          PasswordIssue: "",
        });
      }
    }

    if (name == "cpassword") {
      var CpasswordError = PasswordValidation(name, value);
      this.setState({
        CPasswordIssue: CpasswordError,
      });
      if (passwordError == "") {
        this.setState({
          CPasswordIssue: "",
        });
      }
    }
  };

  handleValidation = (event) => {
    if (event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
    if (
      event.key === "-" ||
      event.key === "+" ||
      event.key === "!" ||
      event.key === "@" ||
      event.key === "#" ||
      event.key === "$" ||
      event.key === "%" ||
      event.key === "^" ||
      event.key === "&" ||
      event.key === "*" ||
      event.key === "(" ||
      event.key === ")"
    ) {
      event.preventDefault();
    }
  };

  render() {
    return (
      <DocumentMeta {...meta}>
        <div className="register-main-outer position-relative d-flex align-items-center flex-wrap">
          <span className="main-bg fadeInLeft animated"></span>
          <div className="register-inner">
            <div className="row">
              <div className="col-12 p-0">
                <div className="register-right fadeInRight animated ">
                  <div className="heading-link-outer">
                    <div className="heading">
                      <h2 className="m-0">Forgot Password</h2>
                    </div>
                  </div>
                  <div className="register-form">
                    {!this.state.codeMatchedStatus ? (
                      <form
                        onSubmit={this.handleMobileSubmit}
                        ref={(el) => (this.myFormRef = el)}
                      >
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group position-relative">
                              <label>Email or Mobile Number</label>
                              <input
                                className="form-control"
                                type="text"
                                autoComplete="off"
                                placeholder="Enter Email or Mobile Number"
                                name="Email"
                                maxLength={70}
                                value={this.state.Email}
                                onChange={this.handleChange2}
                                // onBlur={this.handleOnBlurEmail.bind(this)}
                                disabled={
                                  this.state.counter == 0 ? false : true
                                }
                              />
                              <div style={{ color: "red" }}>
                                {this.state.emailError ||
                                  this.state.mobileError}
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label>Verification Code</label>
                              <div className="input-group">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter Verification Code"
                                  name="VerificationCode"
                                  onChange={this.handlecodechange}
                                  onKeyDown={this.handleValidation}
                                  disabled={
                                    this.state.codeMatchedStatus ||
                                    this.state.buttonDisableVerification
                                  }
                                  // onBlur={this.onBlurVerificationCode.bind(
                                  //   this
                                  // )}
                                  value={this.state.VerificationCode}
                                  aria-label="Input group example"
                                  aria-describedby="btnGroupAddon"
                                />

                                <div className="input-group-prepend">
                                  <button
                                    className="btn btn_man"
                                    id="btnGroupAddon"
                                    type="button"
                                    onClick={this.getCode}
                                    disabled={
                                      this.state.codeMatchedStatus ||
                                      this.state.btnDisable
                                    }
                                  >
                                    {this.state.timerText}
                                    {"  "}
                                    {this.state.counter == 0
                                      ? this.state.textForCode
                                      : this.state.counter}
                                  </button>
                                </div>
                              </div>
                              <div style={{ color: "red" }}>
                                {this.state.verificationError}
                              </div>
                            </div>
                          </div>
                          {!this.state.codeMatchedStatus && (
                            <div className="col-md-6 col-12">
                              <div className="form-group">
                                <button className="btn btn_man" type="submit">
                                  Submit
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </form>
                    ) : (
                      <form onSubmit={this.handleChangePasswordSubmit}>
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label>Password</label>
                              <div className="eye_pass">
                                <input
                                  className="form-control"
                                  type={this.state.type}
                                  name="password"
                                  id="Password"
                                  placeholder="Enter Password"
                                  onBlur={this.handleBlurChange}
                                  value={this.state.Password}
                                  onChange={this.handleChange101}
                                />
                                <span
                                  className="password__show eye1"
                                  onClick={() => {
                                    this.setState({
                                      type:
                                        this.state.type == "text"
                                          ? "password"
                                          : "text",
                                    });
                                  }}
                                >
                                  {this.state.type === "text" ? (
                                    <i className="las la-eye"></i>
                                  ) : (
                                    <i className="las la-low-vision"></i>
                                  )}
                                </span>
                                {this.state.PasswordIssue && (
                                  <div style={{ color: "red" }}>
                                    {this.state.PasswordIssue}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label>Confirm Password</label>

                              <div className="form-group eye_pass">
                                <input
                                  className="form-control"
                                  type={this.state.type1}
                                  placeholder="Enter Confirm Password"
                                  onBlur={this.handleBlurChange}
                                  name="cpassword"
                                  id="CPassword"
                                  onChange={this.handleChange101}
                                  value={this.state.CPassword}
                                />
                                <span
                                  className="password__show eye1"
                                  onClick={() => {
                                    this.setState({
                                      type1:
                                        this.state.type1 == "text"
                                          ? "password"
                                          : "text",
                                    });
                                  }}
                                >
                                  {this.state.type1 === "text" ? (
                                    <i className="las la-eye"></i>
                                  ) : (
                                    <i className="las la-low-vision"></i>
                                  )}
                                </span>

                                {this.state.CPasswordIssue && (
                                  <div style={{ color: "red" }}>
                                    {this.state.CPasswordIssue}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <button className="btn w100 btn_man">Submit</button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentMeta>
    );
  }
}

export default Forgot;
